import VideoSlide from './VideoSlide';

export default VideoSlide;
